import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=58b01b5e&scoped=true"
import script from "./TruncatedText.vue?vue&type=script&lang=js"
export * from "./TruncatedText.vue?vue&type=script&lang=js"
import style0 from "./TruncatedText.vue?vue&type=style&index=0&id=58b01b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b01b5e",
  null
  
)

export default component.exports